"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeciPascal = exports.MilliBar = exports.Bar = exports.FeetOfWaterColumn = exports.InchOfWaterColumn = exports.InchOfMercury = exports.PoundForcePerSquareFoot = exports.PoundForcePerSquareInch = exports.NewtonPerSquareMeter = exports.HectoPascal = exports.KiloPascal = exports.Pascal = void 0;
var uom_1 = require("uom");
exports.Pascal = uom_1.UnitFormat.createUnitFormat("Pa", 0);
exports.KiloPascal = uom_1.UnitFormat.createUnitFormat("kPa", 2);
exports.HectoPascal = uom_1.UnitFormat.createUnitFormat("hPa", 2);
exports.NewtonPerSquareMeter = uom_1.UnitFormat.createUnitFormat("N/m²", 0);
exports.PoundForcePerSquareInch = uom_1.UnitFormat.createUnitFormat("psi", 2);
exports.PoundForcePerSquareFoot = uom_1.UnitFormat.createUnitFormat("psf", 2);
exports.InchOfMercury = uom_1.UnitFormat.createUnitFormat("in HG", 2);
exports.InchOfWaterColumn = uom_1.UnitFormat.createUnitFormat("in WC", 2);
exports.FeetOfWaterColumn = uom_1.UnitFormat.createUnitFormat("ft WC", 2);
exports.Bar = uom_1.UnitFormat.createUnitFormat("bar", 2);
exports.MilliBar = uom_1.UnitFormat.createUnitFormat("mbar", 2);
exports.DeciPascal = uom_1.UnitFormat.createUnitFormat("dPa", 2);
//# sourceMappingURL=pressure-format.js.map